/**
 * @generated SignedSource<<6039ad5cf97baf92d16181d1d112331e>>
 * @relayHash 18ea3b97c85ac4983c9582e4a375800f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7b4338166977a2b02ce8f12d672b7c6e98d727e4a69dd17ebd1df8dcb020605a

import type { ConcreteRequest, Query } from 'relay-runtime';
export type DevAiFlowPipelinesStatus = "FAILED" | "IN_PROGRESS" | "PROVISIONED" | "STARTING" | "STOPPED" | "%future added value";
export type DevAiFlowSessionsStatus = "COMPLETED" | "FAILED" | "IN_PROGRESS" | "PAUSED" | "PENDING" | "%future added value";
export type flowScreen_loadFlowQuery$variables = {
  cloudId: string;
  sessionId: string;
};
export type flowScreen_loadFlowQuery$data = {
  readonly devai_flowSessionGetByIDAndCloudID: {
    readonly additionalInfoJSON: string | null | undefined;
    readonly createdAt: string | null | undefined;
    readonly id: string;
    readonly pipelines: ReadonlyArray<{
      readonly status: DevAiFlowPipelinesStatus | null | undefined;
      readonly url: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly status: DevAiFlowSessionsStatus | null | undefined;
  } | null | undefined;
};
export type flowScreen_loadFlowQuery = {
  response: flowScreen_loadFlowQuery$data;
  variables: flowScreen_loadFlowQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sessionId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "sessionId",
    "variableName": "sessionId"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "createdAt"
},
v5 = {
  "kind": "ScalarField",
  "name": "status"
},
v6 = {
  "kind": "ScalarField",
  "name": "additionalInfoJSON"
},
v7 = {
  "kind": "ScalarField",
  "name": "url"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "flowScreen_loadFlowQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "DevAiFlowSession",
        "kind": "LinkedField",
        "name": "devai_flowSessionGetByIDAndCloudID",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "concreteType": "DevAiFlowPipeline",
            "kind": "LinkedField",
            "name": "pipelines",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "flowScreen_loadFlowQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "DevAiFlowSession",
        "kind": "LinkedField",
        "name": "devai_flowSessionGetByIDAndCloudID",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "concreteType": "DevAiFlowPipeline",
            "kind": "LinkedField",
            "name": "pipelines",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/),
              (v3/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "7b4338166977a2b02ce8f12d672b7c6e98d727e4a69dd17ebd1df8dcb020605a",
    "metadata": {},
    "name": "flowScreen_loadFlowQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8f0e1d26b6a07a82e822647006422c30";

export default node;
